import ClienteForm from './ClienteForm.vue'

export default ClienteForm
